import { ExpandMoreRounded as ExpandIcon, AssessmentOutlined as ReportsIcon } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const reportsItemsConfig = [
  { permission: 4, label: 'Received Receipt Report', to: '/reports/receive-receipt' },
  { permission: 32, label: 'Transaction Report', to: '/reports/transaction-report' },
  { permission: 37, label: 'Cash Outflow Report', to: '/reports/cheque-report' },
  { permission: 103, label: 'Audit Report', to: '/reports/audit-report' },
  {
    permission: 89,
    label: ' Transaction for Creation of Cheque Report',
    to: '/reports/transaction-for-creation-cheque-report',
  },
  {
    permission: 90,
    label: 'Cheques Releasing -  Treasury',
    to: '/reports/cheques-for-releasing-to-treasury-report',
  },
  {
    permission: 91,
    label: 'Cheques Releasing -  Tagging',
    to: '/reports/cheques-for-releasing-to-tagging-report',
  },
  {
    permission: 92,
    label: 'Cheque Report (Cheque created of Treasury)',
    to: '/reports/created-cheque-report',
  },
  {
    permission: 93,
    label: 'Pending for Releasing to Tagging Report',
    to: '/reports/pending-for-releasing-to-tagging-report',
  },
  {
    permission: 94,
    label: 'Pending to Release to Supplier Report',
    to: '/reports/pending-release-to-supplier-report',
  },
  {
    permission: 95,
    label: 'Released to Supplier Report',
    to: '/reports/released-to-supplier-report',
  },
  {
    permission: 96,
    label: 'Cheque Cleared Report',
    to: '/reports/cheque-cleared-report',
  },
];

const SidebarReportsDropdown = ({ RouterLink, user, activeDropdown }) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/reports/gi));

  return (
    <Accordion elevation={0} square disableGutters>
      <AccordionSummary
        className={isActiveDropdown ? `FstoSidebarActiveDropdown-root ${color}` : `FstoSidebarDropdown-root ${color}`}
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ReportsIcon />
        <Typography variant="sidebar">Reports</Typography>
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {reportsItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
              </RouterLink>
            ),
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarReportsDropdown;
